var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:_vm.refId ? _vm.refId : _vm.id,staticClass:"my-echarts",style:(_vm.styleStr
  ? _vm.styleStr
  : { width: _vm.width ? `${_vm.width}px` : '', height: _vm.height ? `${_vm.height}px` : '' }),attrs:{"id":_vm.refId ? _vm.refId : _vm.id}})
}
var staticRenderFns = []

export { render, staticRenderFns }